import Title from "../Title/Title";

const Conference = () => {
  return (
    <section className="w-full mb-10">
      <Title text="Our Conferences" />
      <img
        src="/assets/conference.png"
        className="w-full"
        alt="What AI is replacing and How you can win?"
      />
    </section>
  );
};
export default Conference;
